// Generated file - do not change manually!
/**
 * Defines the horizontal alignment of <code>Popover</code>
 */
export var PopoverHorizontalAlign;
(function (PopoverHorizontalAlign) {
    /**
     * Popover is centered
     */
    PopoverHorizontalAlign["Center"] = "Center";
    /**
     * Popover opens on the left side of the target
     */
    PopoverHorizontalAlign["Left"] = "Left";
    /**
     * Popover opens on the right side of the target
     */
    PopoverHorizontalAlign["Right"] = "Right";
    /**
     * Popover is stretched
     */
    PopoverHorizontalAlign["Stretch"] = "Stretch";
})(PopoverHorizontalAlign || (PopoverHorizontalAlign = {}));
